namespace SP {
    export function bindClickHold(button: HTMLElement, longduration: number, short: () => void, long: () => void) {
        let clicked = false;
        let to: NodeJS.Timeout = null;

        let up = () => {
            document.removeEventListener("pointerup", up);
            clearTimeout(to);
            if (!clicked) {
                console.log("click");
                short();
            }
        }


        let down = () => {
            clicked = false;
            document.addEventListener("pointerup", up);
            to = setTimeout(() => {
                long();
                clicked = true;
                console.log("long click");

            }, longduration);
        }

        button.addEventListener("pointerdown", down);
    }
    
}